import { T } from "@repo/transifex";
import { useCountdown } from "~/hooks/use-countdown";

import { ModalTitle } from "../shared/modal-title";
import { ModalButton } from "../shared/modal-button";
import { INACTIVE_WARNING_DURATION } from "../constants";
import { ModalButtonGroup } from "../shared/modal-button-group";
import { Modal } from "../shared/modal";

type TimeoutModalProps = {
  onClose: () => void;
  onConfirm: () => void;
};

export const InactiveModal = ({ onClose, onConfirm }: TimeoutModalProps) => {
  const { timeLeftInSeconds } = useCountdown({
    countdownDurationInSeconds: INACTIVE_WARNING_DURATION,
    onCountdownFinished: onClose
  });

  return (
    <Modal backdropVariant="idle">
      <div className="flex flex-col gap-y-32 px-40 text-center">
        <ModalTitle size="8xl" variant="info" weight="black">
          <T _str="Are you there?" />
        </ModalTitle>
        <p className="text-5xl font-semibold text-kiosk-text-white">
          <T
            _str="Cancelling order in {timeLeftInSeconds}"
            timeLeftInSeconds={timeLeftInSeconds}
          />
        </p>
        <ModalButtonGroup direction="vertical">
          <ModalButton variant="idle" onClick={onConfirm}>
            <T _str="Yes, I'm here" />
          </ModalButton>

          <ModalButton variant="transparent" onClick={onClose}>
            <T _str="Next customer" />
          </ModalButton>
        </ModalButtonGroup>
      </div>
    </Modal>
  );
};
